export const movementHeadersText: string[] = [
  'Pedido',
  'Matéria prima',
  'Status',
  'Quantidade',
  'Peso anterior',
  'Peso novo',
  'Comp. anterior',
  'Comp. novo',
  'Data',
];

export const movementFields: string[] = [
  'ploomesOrderId',
  'rawMaterialName',
  'status',
  'quantity',
  'oldTotalWeight',
  'newTotalWeight',
  'oldLengthInMm',
  'newLengthInMm',
  'createdAt',
];